/*
temporary fixes:
- put a fake "export class fs {}" into node_js/fs/index.js
- change "const BpmnModdle = require('bpmn-moddle').default;" inside bpmn-auto-layout/lib/autolayout.js
*/

import './index.css';
import { BPMNator as bpmnator } from 'bpmnator';
import 'bpmn-js/dist/assets/diagram-js.css';
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn.css';

import Viewer from 'bpmn-js/lib/NavigatedViewer';

import fileDownload from 'js-file-download';

// fileDownload(data, filename, mime)
// mime is optional

const BpmnJS = require('bpmn-js');
const yaml = require('js-yaml');

let _BPMNoutput = '';

document.getElementById('loadYaml').addEventListener('click',loadYaml);
document.getElementById('file-input').addEventListener('change',loadYamlFile);
document.getElementById('saveYaml').addEventListener('click',saveYaml);
document.getElementById('saveBPMN').addEventListener('click',saveBPMN);

function loadYaml() {
  console.log(1);
  document.getElementById('file-input').click();
}
function loadYamlFile() {
  let fileInput = document.getElementById('file-input') as HTMLInputElement;
  const reader = new FileReader();
  reader.onload = (e) => {
    const content = e.target.result as string;
    try {
      const obj = yaml.load(content);
      if (typeof(obj) == 'object')
        ed.setValue(content);
      else
        writeBpmnatorOutput('Invalid input file');
    }
    catch (e) {
      writeBpmnatorOutput(e.message);
    }
    document.getElementById('file-input').removeAttribute('file');
    document.getElementById('file-input').removeAttribute('value');
  }
  
  for (let file of fileInput.files) {
    reader.readAsText(file);
  }
}
function saveYaml() {
  fileDownload(ed.getValue(), getProcessName()+'.BPMNator.yaml', 'text/yaml');
}
function saveBPMN() {
  fileDownload(_BPMNoutput, getProcessName()+'.BPMNator.bpmn', 'text/xml');
}
function getProcessName(): string {
  const obj = yaml.load(ed.getValue());
  return obj.process as string;
}

function GoBPMNator (content): boolean {
  const b = new bpmnator();
  try {
    if (b.LoadYAMLbyContent(content)) {
      if (b.BuildProcess()) {   
        b.ProduceBPMN().then(async (bpmn_output) => {
          _BPMNoutput = bpmn_output;
          writeBpmnatorOutput(bpmn_output);
          
          document.getElementById('canvas').innerHTML = '';
          const viewer = new Viewer({ container: '#canvas' });

          try {
            await viewer.importXML(bpmn_output);
            
            
          } catch (err) {
            // err...
          }


        }
        
          
        );
        return true;
      } else writeBpmnatorOutput(b.LastError);
    } else writeBpmnatorOutput(b.LastError);
  }
  catch (e) {
    alert(e);
    writeBpmnatorOutput(e.message);
  }
  return false;
}

function writeBpmnatorOutput (txt) {
  document.getElementById('bpmnator-output').innerHTML
   = (new Date()).toString()+"\n\n"+txt+"\n\n"+document.getElementById('bpmnator-output').innerHTML;
}

//import { JSONSchemaForSchemaStoreOrgCatalogFiles } from '@schemastore/schema-catalog';
import { CancellationToken } from 'monaco-editor/esm/vs/base/common/cancellation';
import { getDocumentSymbols } from 'monaco-editor/esm/vs/editor/contrib/documentSymbols/documentSymbols';
import {
  editor,
  Environment,
  languages,
  Position,
  Range,
  Uri,
} from 'monaco-editor/esm/vs/editor/editor.api';
import { SchemasSettings, setDiagnosticsOptions } from 'monaco-yaml';

// NOTE: This will give you all editor featues. If you would prefer to limit to only the editor
// features you want to use, import them each individually. See this example: (https://github.com/microsoft/monaco-editor-samples/blob/main/browser-esm-webpack-small/index.js#L1-L91)
import 'monaco-editor';

import defaultSchemaUri from 'bpmnator/schemas/BPMNator.schema.json';

declare global {
  interface Window {
    MonacoEnvironment: Environment;
  }
}

window.MonacoEnvironment = {
  getWorker(moduleId, label) {
    switch (label) {
      case 'editorWorkerService':
        return new Worker(new URL('monaco-editor/esm/vs/editor/editor.worker', import.meta.url));
      case 'yaml':
        return new Worker(new URL('monaco-yaml/yaml.worker', import.meta.url));
      default:
        throw new Error(`Unknown label ${label}`);
    }
  },
};

const defaultSchema: SchemasSettings = {
  uri: defaultSchemaUri,
  fileMatch: ['*'],
};

setDiagnosticsOptions({
  schemas: [defaultSchema],
  validate: true,
  enableSchemaRequest: true,
  format: true,
  hover: true,
  completion: true
});

const value = `process: #put here process name

`;

const ed = editor.create(document.getElementById('editor'), {
  automaticLayout: true,
  model: editor.createModel(value, 'yaml', Uri.parse('monaco-yaml.yaml')),
  theme: window.matchMedia('(prefers-color-scheme: dark)').matches ? 'vs-dark' : 'vs-light',
});


/*
const select = document.getElementById('schema-selection') as HTMLSelectElement;

fetch('https://www.schemastore.org/api/json/catalog.json').then(async (response) => {
  if (!response.ok) {
    return;
  }
  const catalog = (await response.json()) as JSONSchemaForSchemaStoreOrgCatalogFiles;
  const schemas = [defaultSchema];
  catalog.schemas.sort((a, b) => a.name.localeCompare(b.name));
  for (const { fileMatch, name, url } of catalog.schemas) {
    const match =
      typeof name === 'string' && fileMatch?.find((filename) => /\.ya?ml$/i.test(filename));
    if (!match) {
      continue;
    }
    const option = document.createElement('option');
    option.value = match;

    option.textContent = name;
    select.append(option);
    schemas.push({
      fileMatch: [match],
      uri: url,
    });
  }

  setDiagnosticsOptions({
    validate: true,
    enableSchemaRequest: true,
    format: true,
    hover: true,
    completion: true,
    schemas,
  });
});

select.addEventListener('change', () => {
  const oldModel = ed.getModel();
  const newModel = editor.createModel(oldModel.getValue(), 'yaml', Uri.parse(select.value));
  ed.setModel(newModel);
  oldModel.dispose();
});
*/


function* iterateSymbols(
  symbols: languages.DocumentSymbol[],
  position: Position,
): Iterable<languages.DocumentSymbol> {
  for (const symbol of symbols) {
    if (Range.containsPosition(symbol.range, position)) {
      yield symbol;
      yield* iterateSymbols(symbol.children, position);
    }
  }
}

ed.onDidChangeCursorPosition(async (event) => {
  const breadcrumbs = document.getElementById('breadcrumbs');
  const symbols = await getDocumentSymbols(ed.getModel(), false, CancellationToken.None);
  while (breadcrumbs.lastChild) {
    breadcrumbs.lastChild.remove();
  }
  for (const symbol of iterateSymbols(symbols, event.position)) {
    const breadcrumb = document.createElement('span');
    breadcrumb.setAttribute('role', 'button');
    breadcrumb.classList.add('breadcrumb');
    breadcrumb.textContent = symbol.name;
    breadcrumb.title = symbol.detail;
    if (symbol.kind === languages.SymbolKind.Array) {
      breadcrumb.classList.add('array');
    } else if (symbol.kind === languages.SymbolKind.Module) {
      breadcrumb.classList.add('object');
    }
    breadcrumb.addEventListener('click', () => {
      ed.setPosition({
        lineNumber: symbol.range.startLineNumber,
        column: symbol.range.startColumn,
      });
      ed.focus();
    });
    breadcrumbs.append(breadcrumb);
  }
});

editor.onDidChangeMarkers(([resource]) => {
  const problems = document.getElementById('problems');
  const markers = editor.getModelMarkers({ resource });
  while (problems.lastChild) {
    problems.lastChild.remove();
  }

  for (const marker of markers) {
    const wrapper = document.createElement('div');
    wrapper.setAttribute('role', 'button');
    const codicon = document.createElement('div');
    const text = document.createElement('div');
    wrapper.classList.add('problem');
    codicon.classList.add('codicon', 'codicon-warning');
    text.classList.add('problem-text');
    text.textContent = marker.message;
    wrapper.append(codicon, text);
    wrapper.addEventListener('click', () => {
      ed.setPosition({ lineNumber: marker.startLineNumber, column: marker.startColumn });
      ed.focus();
    });
    problems.append(wrapper);
  }
});


let content = {};

setInterval(() => {
  const problems = document.getElementById('problems').innerHTML;
  let ok = false;
  if (problems == '') {
    try {
      const newContent = yaml.load(ed.getValue());
      if (JSON.stringify(content) != JSON.stringify(newContent)) {
        content = newContent;
        ok = GoBPMNator(ed.getValue());
      } else ok = true;
    } catch {}
  }
  const saveBPMNbtn =  document.getElementById('saveBPMN');
  
  if (ok) saveBPMNbtn.removeAttribute('disabled');
  else saveBPMNbtn.setAttribute('disabled','disabled');
},2000);